import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { headerSettings } from '@/hooks/useContent';

const Navbar = () => {
  const content = headerSettings;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src={content.logo}
              alt={content.logo_alt}
              className="h-12 w-auto transition-all duration-300"
              style={{ 
                filter: isScrolled ? 'none' : 'brightness(0) invert(1)',
              }}
              data-testid="navbar-logo"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {content.nav_links?.map((link, index) => (
              <button 
                key={index}
                onClick={() => scrollToSection(link.target)}
                className="nav-link text-base font-medium transition-colors duration-200"
                data-testid={`nav-link-${link.target}`}
              >
                {link.label}
              </button>
            ))}
            <button 
              onClick={() => scrollToSection(content.cta_target)}
              className="cta-button px-6 py-2.5 rounded-md font-medium transition-all duration-300"
              data-testid="navbar-cta"
            >
              {content.cta_text}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2"
              style={{ color: '#61525a' }}
              data-testid="mobile-menu-button"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t" data-testid="mobile-menu">
          <div className="px-6 py-4 space-y-3">
            {content.nav_links?.map((link, index) => (
              <button 
                key={index}
                onClick={() => scrollToSection(link.target)}
                className="block w-full text-left py-2 text-base font-medium"
                style={{ color: '#1e1919' }}
                data-testid={`mobile-nav-link-${link.target}`}
              >
                {link.label}
              </button>
            ))}
            <button 
              onClick={() => scrollToSection(content.cta_target)}
              className="w-full text-center cta-button px-6 py-2.5 rounded-md font-medium transition-all duration-300"
              data-testid="mobile-navbar-cta"
            >
              {content.cta_text}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
